import React from "react";
import CrudPage from "../components/CrudPage";
import StatusBadge from "../components/StatusBadge";
export default function Locations() {
  const columns = [
    { key: "name", label: "Location", render: (r) => <span className="font-medium" style={{ color: "#3B2722" }}>{r.name}{r.flagship && <span className="ml-2 text-xs px-1.5 py-0.5 rounded" style={{ background: "#E7D0AD", color: "#6B1717" }}>Flagship</span>}</span> },
    { key: "state", label: "State" }, { key: "manager", label: "Manager" }, { key: "phone", label: "Phone" },
    { key: "status", label: "Status", render: (r) => <StatusBadge status={r.status} /> },
  ];
  const fields = [
    { name: "name", label: "Location Name", required: true }, { name: "state", label: "State" },
    { name: "manager", label: "Manager" }, { name: "phone", label: "Phone" },
    { name: "address", label: "Address", type: "textarea", full: true },
    { name: "status", label: "Status", type: "select", default: "active", options: [{ value: "active", label: "Active" }, { value: "inactive", label: "Inactive" }] },
  ];
  return <CrudPage title="Locations" subtitle="Sir Monty outlets & central warehouse" module="locations" endpoint="/locations" columns={columns} fields={fields} searchKeys={["name", "state"]} testId="locations" addLabel="New Location" defaults={{ status: "active" }} />;
}
